// const dev = 'http://apitest.jimicloud.com';//测试的
// const dev = 'http://10.0.15.105:810';//测试环境
const dev = 'https://openapi.tuqiangol.com'; //线上的
// const dev = 'http://47.107.242.239:8872'; //uat
// const dev = 'http://172.16.0.178:8383/tuqiang-campus';
const api = {
  GET_CURRENT_USER: dev + '/getCurrentUser', //GET 获取用户信息
  GET_Status: dev + '/getStatus', //GET 获取设备状态
  GET_PAGEPOWER: dev + '/getPagePower', //GET 获取指令设置权限
  POST_PLAYBACK_RECORD: dev + '/playbackRecord', //POST回放记录
  POST_ALARMINFO: dev + '/alarmInfo/queryAlarmType', //post获取所有告警类型
  POST_QUERYALARMINFO: dev + '/alarmInfo/queryAlarmInfo', //post获取告警列表
  POST_INSTRUCTION: dev + '/instruction/queryInstructionType', //获取设备指令类型,
  POST_queryInstructionByParam: dev + '/instruction/queryInstructionByParam', //获取设备指令详情
  POST_geozone: dev + '/geozone/queryGeozoneInfo', //获取围栏列表
  POST_setGeozoneAlarm: dev + '/geozone/setGeozoneAlarm', //设置围栏进出告警
  POST_deleteGeozone: dev + '/geozone/deleteGeozone', //删除围栏
  POST_addGeozone: dev + '/geozone/addGeozone', //添加围栏
  POST_updateGeozone: dev + '/geozone/updateGeozone', //修改围栏
  POST_instruction: dev + '/instruction/sendInstruction', //发送设备指令
  GET_projectShowName: dev + '/getProjectShowName' //某个客户要改的title
};
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js